import React from 'react';
import style from './block.module.scss';
import {ReactComponent as Square} from "./square.svg";


function TopPage({title, text}){
    return <div className={style.block}>
        <div className={style.container}>
            <div className={style.textBlock}>
                <Square />
                <h1>{title}</h1>
                <div className={style.text}>{text}</div>
            </div>
        </div>
    </div>
}

export default TopPage
